module.exports = __webpack_public_path__ + "static/media/shweta_blog.d2fd8893.jpg";